import { WizardStep } from "../../common/types/wizard";
import { ParameterValue } from "../../common/types/parameters";

// Id <> index conversion

export function getIndexFromId(id: string, wizardSteps: WizardStep[]): number {
  return wizardSteps.findIndex((step) => step.id === id);
}

// Inputs

export function getUserInputForStepId(
  id: string,
  wizardSteps: WizardStep[]
): ParameterValue[] | undefined {
  return wizardSteps.find((step) => step.id === id)?.inputParameters;
}
